import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { login, getProfileInfo } from "../../services/api";
import { Container, TextField, Button, Box, Typography, useTheme } from "@mui/material";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import tab_logo from "../../assets/tab_logo.jpg";

const TamilNaduMap = () => (
  <MapContainer
    center={[12.881276, 79.911454]}
    zoom={7}
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: -1,
      opacity: 0.8,
    }}
  >
    <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
  </MapContainer>
);

const Login = () => {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const { login: loginContext } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Step 1: Login (get token)
      const response = await login(credentials);
      const token = response.data.token;

      // Step 2: Get profile info using token
      const profile = await getProfileInfo(token);

      // Step 3: Store both in AuthContext
      loginContext(token, profile);

      // Step 4: Redirect based on username
      if (profile.username === "telnet") navigate("/dashboard");
      else navigate("/gps-map");
    } catch (error) {
      console.error("Login error:", error);
      alert("Login failed. Please check your credentials.");
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TamilNaduMap />

      <Container maxWidth="xs">
        <Box
          sx={{
            p: 4,
            bgcolor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
            zIndex: 1,
          }}
        >
          <img
            src={tab_logo}
            alt="Logo"
            style={{ width: "300px", marginBottom: "16px" }}
          />
          <Typography variant="h5" color="textPrimary">
            Login
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              margin="normal"
              variant="outlined"
              onChange={(e) =>
                setCredentials({ ...credentials, username: e.target.value })
              }
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              variant="outlined"
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              type="submit"
            >
              Login
            </Button>
          </form>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
